(function () {
  'use strict';

  const REASONS = new Set(['beneficii_neclare', 'pret_lunar', 'am_uitat', 'alt_furnizor', 'alt_motiv']);
  const RESTART_REASONS = new Set(['abonament_pret', 'beneficii_utilizare', 'protocol_personalizat', 'teste_puritate', 'nu_ma_intereseaza']);

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
      const random = Math.floor(Math.random() * 16);
      const value = character === 'x' ? random : ((random & 3) | 8);
      return value.toString(16);
    });
  }

  function safeParam(params, key, fallback) {
    const value = (params.get(key) || '').trim();
    return /^[a-zA-Z0-9_.:-]{1,100}$/.test(value) ? value : fallback;
  }

  function initializeSurvey(root) {
    const form = root.querySelector('[data-cfs-form]');
    const endpoint = root.dataset.endpoint;
    const otherField = root.querySelector('[data-other-field]');
    const otherText = root.querySelector('[data-other-text]');
    const characterCount = root.querySelector('[data-character-count]');
    const errorSummary = root.querySelector('[data-error-summary]');
    const submitButton = root.querySelector('[data-submit-button]');
    const submitLabel = root.querySelector('[data-submit-label]');
    const submitStatus = root.querySelector('[data-submit-status]');
    const successPanel = root.querySelector('[data-success-panel]');
    const copyButton = root.querySelector('[data-copy-coupon]');
    const copyLabel = root.querySelector('[data-copy-label]');
    const startedAt = Date.now();
    const params = new URLSearchParams(window.location.search);

    if (!form || !endpoint) return;

    function syncOptionState(name) {
      form.querySelectorAll('input[name="' + name + '"]').forEach(function (input) {
        input.closest('.cfs__option').classList.toggle('is-selected', input.checked);
      });
      const fieldset = form.querySelector('[data-question="' + name + '"]');
      if (fieldset) fieldset.classList.remove('has-error');
    }

    function syncOtherField() {
      const selected = form.querySelector('input[name="reason"]:checked');
      const shouldShow = selected && selected.value === 'alt_motiv';
      otherField.hidden = !shouldShow;
      otherText.disabled = !shouldShow;
      if (!shouldShow) {
        otherText.value = '';
        characterCount.textContent = '0';
      }
    }

    form.addEventListener('change', function (event) {
      if (event.target.matches('input[type="radio"]')) {
        syncOptionState(event.target.name);
        syncOtherField();
        errorSummary.hidden = true;
      }
    });

    otherText.addEventListener('input', function () {
      characterCount.textContent = String(otherText.value.length);
    });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      submitStatus.textContent = '';
      errorSummary.hidden = true;

      const data = new FormData(form);
      const reason = String(data.get('reason') || '');
      const restartReason = String(data.get('restart_reason') || '');
      const invalidQuestions = [];

      if (!REASONS.has(reason)) invalidQuestions.push('reason');
      if (!RESTART_REASONS.has(restartReason)) invalidQuestions.push('restart_reason');

      form.querySelectorAll('[data-question]').forEach(function (fieldset) {
        fieldset.classList.toggle('has-error', invalidQuestions.includes(fieldset.dataset.question));
      });

      if (invalidQuestions.length) {
        errorSummary.hidden = false;
        errorSummary.focus();
        return;
      }

      const payload = {
        submission_id: uuid(),
        reason: reason,
        restart_reason: restartReason,
        other_reason: reason === 'alt_motiv' ? otherText.value.trim() : '',
        source: safeParam(params, 'source', 'omnisend'),
        campaign_ref: safeParam(params, 'campaign', 'feedback-comanda2'),
        form_version: String(data.get('form_version') || 'feedback-comanda-v1'),
        landing_path: window.location.pathname.slice(0, 180),
        website: String(data.get('website') || ''),
        elapsed_ms: Date.now() - startedAt
      };

      submitButton.disabled = true;
      submitButton.classList.add('is-loading');
      submitLabel.textContent = 'Se trimite…';

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        if (!response.ok) throw new Error('Submit failed with status ' + response.status);

        form.hidden = true;
        successPanel.hidden = false;
        successPanel.focus();
        successPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'customer_feedback_submitted',
          feedback_reason: reason,
          feedback_restart_reason: restartReason,
          feedback_campaign: payload.campaign_ref
        });
      } catch (error) {
        submitStatus.textContent = 'Răspunsul nu a putut fi trimis. Vă rugăm să încercați din nou.';
        submitButton.disabled = false;
        submitButton.classList.remove('is-loading');
        submitLabel.textContent = 'Trimite răspunsurile';
      }
    });

    copyButton.addEventListener('click', async function () {
      try {
        await navigator.clipboard.writeText('COMANDA2');
        copyLabel.textContent = 'Cod copiat';
      } catch (error) {
        copyLabel.textContent = 'COMANDA2';
      }
      window.setTimeout(function () { copyLabel.textContent = 'Copiază codul'; }, 2200);
    });
  }

  document.querySelectorAll('[data-customer-feedback-survey]').forEach(initializeSurvey);
})();
